import React, { useState } from 'react';
import styles from './Login.module.scss';
import api, { login } from '../../services/api.tsx';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/AuthContext.tsx';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const { loginSession } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await login(email, password);
      console.log('Sucesso:', response);
      if (response.token) {
        loginSession(response.user, response.token);
        navigate('/Home');
      }
    } catch (error) {
      console.error('Erro ao logar:', error);
    }
    
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logo}>Sergipanidade</div>

        <h2 className={styles.title}>Bem-vindo</h2>
        <p className={styles.subtitle}>Entre para explorar o melhor de Sergipe</p>

        <form onSubmit={handleLogin}>
          <div className={styles.formGroup}>
            <label>E-mail ou usuário</label>
            <div className={styles.inputWrapper}>
              <EmailOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="text" 
                className={styles.input} 
                placeholder="Email ou usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <div className={styles.labelRow}>
              <label>Senha</label>
              <a href="#" className={styles.forgotPass}>Esqueceu?</a>
            </div>
            <div className={styles.inputWrapper}>
              <LockOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="password" 
                className={styles.input} 
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className={styles.btnPrimary} onSubmit={handleLogin}>
            Acessar conta
          </button>
        </form>

        <div className={styles.divider}>ou</div>

        <p className={styles.signupText}>Ainda não tem uma conta?</p>
        <button type="button" className={styles.btnOutline} onClick={() => navigate('/NewUser')}>
          Criar novo Usuario
        </button>
      </div>
    </div>
  );
};

export default Login;